export default {"src":"/_next/static/media/logo-budget.f2b953e0.svg","height":15,"width":66,"blurWidth":0,"blurHeight":0};